
// RESULTADO DE VALIDACIÓN DEL VIDEO
export interface ResultadoValidacionVideo {
    valido: boolean;

    titulo: string;
    mensaje: string;

    // Información del archivo
    formato?: string;
    pesoMB?: number;
    duracion?: number;
}


// CONFIGURACIÓN GENERAL

export const VIDEO_CONFIG = {

    // Duración máxima permitida
    DURACION_MAXIMA_SEGUNDOS: 30,

    // Peso máximo permitido
    PESO_MAXIMO_MB: 10,

    // Únicamente MP4
    FORMATOS_PERMITIDOS: [
        "video/mp4",
    ],
};


// VALIDAR FORMATO
// ÚNICAMENTE SE PERMITE MP4

export const validarFormatoVideo = (
    file: File
): ResultadoValidacionVideo => {

    const extension = file.name
        .split(".")
        .pop()
        ?.toLowerCase();

    // Validamos MIME + extensión
    const mimeValido =
        VIDEO_CONFIG.FORMATOS_PERMITIDOS.includes(
            file.type
        );

    const extensionValida =
        extension === "mp4";


    if (!mimeValido || !extensionValida) {

        return {
            valido: false,

            titulo: "Formato de video no permitido",

            mensaje:
                "El archivo seleccionado no tiene un formato válido. " +
                "Únicamente se permiten videos en formato MP4.",

            formato: extension,
        };
    }


    return {
        valido: true,

        titulo: "",
        mensaje: "",

        formato: extension,
    };
};

// VALIDAR PESO
// MÁXIMO 10 MB

export const validarPesoVideo = (
    file: File
): ResultadoValidacionVideo => {

    const pesoMB =
        file.size / (1024 * 1024);


    if (
        pesoMB >
        VIDEO_CONFIG.PESO_MAXIMO_MB
    ) {

        return {
            valido: false,

            titulo: "Video demasiado pesado",

            mensaje:
                `El video seleccionado pesa ${pesoMB.toFixed(2)} MB. ` +
                `El peso máximo permitido es de ` +
                `${VIDEO_CONFIG.PESO_MAXIMO_MB} MB.`,

            pesoMB,
        };
    }


    return {
        valido: true,

        titulo: "",
        mensaje: "",

        pesoMB,
    };
};

// VALIDAR DURACIÓN
// MÁXIMO 30 SEGUNDOS

export const validarDuracionVideo = (
    duracion: number
): ResultadoValidacionVideo => {


    // Validar que realmente podamos leer la duración
    if (
        !Number.isFinite(duracion) ||
        duracion <= 0
    ) {

        return {
            valido: false,

            titulo: "Duración de video inválida",

            mensaje:
                "No fue posible determinar correctamente la duración del video.",
        };
    }


    if (
        duracion >
        VIDEO_CONFIG.DURACION_MAXIMA_SEGUNDOS
    ) {

        return {
            valido: false,

            titulo: "Duración de video no permitida",

            mensaje:
                `El video seleccionado tiene una duración de ` +
                `${duracion.toFixed(1)} segundos. ` +
                `La duración máxima permitida es de ` +
                `${VIDEO_CONFIG.DURACION_MAXIMA_SEGUNDOS} segundos.`,

            duracion,
        };
    }


    return {
        valido: true,

        titulo: "",
        mensaje: "",

        duracion,
    };
};

// VALIDACIÓN COMPLETA
// REGLAS:
// 1. Únicamente MP4
// 2. Máximo 10 MB
// 3. Máximo 30 segundos
// NO se valida:
// - ancho
// - alto
// - pixelaje
// - relación de aspecto

export const validarVideoCompleto = (
    file: File,
    duracion: number
): ResultadoValidacionVideo => {

    // 1. VALIDAR FORMATO
    const resultadoFormato =
        validarFormatoVideo(file);

    if (!resultadoFormato.valido) {

        return resultadoFormato;

    }

    // 2. VALIDAR PESO
    const resultadoPeso =
        validarPesoVideo(file);
    if (!resultadoPeso.valido) {

        return resultadoPeso;

    }

    // 3. VALIDAR DURACIÓN
    const resultadoDuracion =
        validarDuracionVideo(duracion);


    if (!resultadoDuracion.valido) {

        return resultadoDuracion;

    }

    // TODO CORRECTO
    return {

        valido: true,

        titulo: "Video válido",

        mensaje:
            "El video cumple con las reglas establecidas.",

        formato:
            file.name
                .split(".")
                .pop()
                ?.toLowerCase(),

        pesoMB:
            file.size / (1024 * 1024),

        duracion,

    };
};